import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import { useMatchRoute, useNavigate } from "@tanstack/react-router";

import { TaskSet } from "@/core/types";
import { useDeleteTaskSetMutation } from "@/hooks/tasks";
import { useCurrentVenueUuid } from "@/hooks/venues";

import { useModal } from "./useModal";

export default function ConfirmDeleteTaskSet({ taskSet }: { taskSet: TaskSet }) {
  const { close } = useModal();
  const venueUuid = useCurrentVenueUuid();
  const mutation = useDeleteTaskSetMutation(venueUuid);
  const onConfirm = () => {
    mutation.mutate(taskSet.uuid, {
      onSuccess: () => {
        close();
        if (
          matchRoute({
            to: "/gym/$venueUuid/schedule/set/$setUuid",
            fuzzy: true,
          })
        ) {
          navigate({
            from: "/gym/$venueUuid",
            to: "/gym/$venueUuid/schedule/calendar",
            replace: true,
            params: true,
          });
        }
      },
    });
  };

  const navigate = useNavigate();
  const matchRoute = useMatchRoute();

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>
          Deleting this taskset will remove all tasks in the set and delete all unpublished routes.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="danger"
          onClick={() => {
            onConfirm();
          }}
          sx={{ flex: 1 }}
        >
          Continue
        </Button>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
